import React from 'react';
import googleIcon from '../../assets/google_icon.png';
import { Box, CircularProgress, Divider, Grid, Typography } from '@mui/material';
import BackrrLogo from 'assets/Backrr_logo_symbol_white_new.webp';
import { useTheme } from '@emotion/react';
import CustomInputField from '../../ui-components/CustomInputField';
import { BLUEBORDER } from '../../ui-components/CustomButton';
import { Primary } from '../../ui-components/Buttons';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { LoginViaEmail } from '../../api';
import toast from 'react-hot-toast';
import CustomToast from '../../ui-components/CustomToast';
import Cookies from "js-cookie";
import { auth, provider, signInWithPopup, signOut } from "../../firebase";
import * as jwt_decode from 'jwt-decode';
import LinkedinLogin from './LinkedinLogin';
import CustomHeaderIcon from 'ui-components/CustomHeaderIcon';
import { checkForDomain, getDeviceType, navigateToMain, redirectTo, setTokenForAuthorization ,captureUtmParams } from 'utilities/index';
import { RESET_STATE } from 'store/actions';
import { useDispatch } from 'react-redux';
import { useToast } from 'context/ToastContext';
import GoogleLogin from './GoogleLogin';
import mixpanel from 'mixpanel-browser';
import { trackEvent, logUserIn, signUserUp } from 'utilities/mixpanel';


export const LOGIN_GRADIENT = "linear-gradient(135deg, #84aef8 0%, #7852f8 100%)";

// Rounded, hairline-bordered input to match the auth card design
export const INPUT_SX = {
  m: 0,
  "& .MuiFilledInput-root": {
    borderRadius: "10px",
    border: "1px solid #E4E7EC",
    backgroundColor: "#FFFFFF",
  },
  "& .MuiFilledInput-root.Mui-focused": {
    borderColor: "#101828",
  },
  "& .MuiFilledInput-input": {
    padding: "15px 16px",
  },
};

const AuthLogin = () => {
  const onboardingRoute = '/';
  const theme = useTheme();
  const { addToast } = useToast();
  const navigate = useNavigate();
  const dispatch = useDispatch()
  React.useEffect(() => {
    Cookies.remove("IS_MIXPANEL_DISABLED");
    dispatch({ type: RESET_STATE });
  }, [])
  const currentIP = window.location.host;
  const currentLOcation = window.location.pathname;
  const [searchParams, setSearchParams] = useSearchParams()
  // console.log(currentLOcation,"currentLOcation",searchParams.get("ref"))
  const [userData, setUserData] = React.useState(null);
  const [loginMethod, setLoginMethod] = React.useState("email");
  const { mutateAsync: loginViaEmailAsync, status: LoginViaEmailStatus, error: LoginViaEmailError, isLoading, data: loginViaEmailResponse } = LoginViaEmail();

  React.useEffect(() => {
    window.document.getElementsByTagName("body")[0].style.background = "#FFFDFA";
  }, [])

  React.useEffect(() => {
    if (loginViaEmailResponse && loginViaEmailResponse?.data?.statusCode === 200) {
      // else {
      //   loginViaEmailResponse?.is_profile_completed == true ? navigate("/") : navigate("/onboarding");
      // }
      // console.log(loginViaEmailResponse?.is_profile_completed,loginViaEmailResponse?.is_profile_complete == "true")

    }
    if (loginViaEmailResponse && loginViaEmailResponse?.data?.statusCode !== 200) {
      // toast.error(<CustomToast message={loginViaEmailResponse?.data.message} style={{ padding: "0px 15px" }} closeIcon={true} closeIconPosition={"center"} />, {
      //   duration: 4000,
      //   position: 'top-right',
      //   style: {
      //     padding: "15px 30px"
      //   }
      // });
      // addToast(loginViaEmailResponse?.data.message, "error")
    }
  }, [loginViaEmailResponse?.data?.statusCode]);

  React.useEffect(() => {
    window.scrollTo(0, 0); // This is the most reliable and readable
    // for safari
    document.body.scrollTop = 0;
    // for Chrome, Firefox, IE and Opera
    document.documentElement.scrollTop = 0;
  }, []);

  const [emailValue, setEmailValue] = React.useState("");
  const [emailError, setEmailError] = React.useState(false);

  const handleLogin = () => {
    // console.log(currentLOcation,"currentLOcation" ,currentIP)
    setLoginMethod("email");
    loginViaEmailAsync({
      "email": emailValue,
      "devices": {
        "device_token": `${Math.random() * 10}`,
        "device_type": getDeviceType()
      },
      "last_login_ip": `${currentIP}`,
      "auth_provider": "email",
      ...(searchParams.get("utm_source") ? { utm_source: searchParams.get("utm_source") } : {}),
      ...(searchParams.get("utm_campaign") ? { utm_campaign: searchParams.get("utm_campaign") } : {})
    }, {
      onSuccess: (verifyResponse) => {
        captureUtmParams()
        Cookies.set("pathname", window.location?.pathname + window.location?.search);
        if (searchParams.get("utm_campaign")) {
          Cookies.set("utm_campaign", searchParams.get("utm_campaign"));
        }
        const response = verifyResponse?.data?.data;
        if (verifyResponse?.data?.statusCode !== 403) {
          Cookies.remove("email");
          Cookies.set("email", emailValue);
          Cookies.set("step", Number(response?.step))
          if (currentLOcation?.includes("register") && searchParams.get("ref")) {
            Cookies.set("ref", searchParams.get("ref"))
          }
          if (response?.collaborator_data?.connected_id) {
            logUserIn(response?.users)
            trackEvent('Login', {
              // distictID: response?.users?._id,
              email: emailValue,
              "Login Method": "email",
              // timestamp: new Date().toISOString()
            });
          }
          else {
            signUserUp(response?.users)
            trackEvent('Sign Up', {
              // distictID: verifyResponse?.data?.users?._id,
              email: emailValue,
              "Sign Up Method": "email",
              // timestamp: new Date().toISOString()
            });
          }
          Cookies.get("email") && navigate("/verification");
        }
        else {
          setEmailError(true);
        }
      },
      onError: () => {
        setEmailError(true);
      }
    });
  };

  // React.useEffect(() => {
  //   const initAppleSignIn = () => {
  //     window.AppleID.auth.init({
  //       clientId: 'in.backrr.startup',
  //       scope: "name%20email",
  //       redirectURI: "https://startup.backrr.in",
  //       state: 'SignInUserAuthenticationRequest',
  //       usePopup: true
  //     });
  //   };

  //   if (window.AppleID) {
  //     initAppleSignIn();
  //   } else {
  //     const script = document.createElement('script');
  //     script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
  //     script.onload = initAppleSignIn;
  //     document.body.appendChild(script);
  //   }
  // }, []);

  // const handleSignIn = async () => {
  //   await window.AppleID.auth.signIn().then((res) => {
  //     const id_token = res.authorization.id_token;
  //     // console.log(res, "res")
  //     const user = jwt_decode.jwtDecode(id_token);
  //     // console.log(user, "user")
  //     setLoginMethod("appleid");
  //     loginViaEmailAsync({
  //       "email": user?.email,
  //       "devices": {
  //         "device_token": `${Math.random() * 10}`,
  //         "device_type": getDeviceType()
  //       },
  //       "last_login_ip": `${currentIP}`,
  //       "auth_provider": "appleid"
  //     }, {
  //       onSuccess: (response) => {
  //         setTokenForAuthorization(response?.data?.data?.userData?.token);
  //         Cookies.set("email", user?.email)
  //         if (currentLOcation?.includes("register") && searchParams.get("ref")) {
  //           Cookies.set("ref", searchParams.get("ref"))
  //         }
  //         // Cookies.set("is_profile_complete", response?.data?.data?.is_profile_completed);
  //         if (response?.data?.data?.is_profile_completed == true) {
  //           Cookies.set("is_profile_complete", true)
  //           navigate("/");
  //         }
  //         else {
  //           Cookies.set("is_profile_complete", false)
  //           Cookies.set("step", Number(response?.data?.data?.step))
  //           navigate(onboardingRoute);
  //         }
  //       }
  //     });
  //   }).catch((error) => {
  //     console.error(error);
  //   });
  // };

  const handleSignInGoogle = async () => {
    setLoginMethod("google");
    await signOut(auth);
    await signInWithPopup(auth, provider)
      .then((result) => {
        // console.log(result, "result?.user");
        Cookies.set("userDetails", JSON.stringify({ first_name: result?._tokenResponse?.firstName, last_name: result?._tokenResponse?.lastName, mobile_number: result?.user?.phoneNumber }))
        loginViaEmailAsync({
          "email": result?.user?.email,
          "devices": {
            "device_token": `${Math.random() * 10}`,
            "device_type": getDeviceType()
          },
          "last_login_ip": `${currentIP}`,
          "auth_provider": "google"
        }, {
          onSuccess: (verifyResponse) => {
            const response = verifyResponse?.data?.data;
            if (currentIP?.includes("localhost")) {
              if (response?.collaborator_data?.connected_id) {
                Cookies.set("X-ST-ID", response?.collaborator_data?.connected_id);
              }
              response?.userData?.token && setTokenForAuthorization(response?.userData?.token);
            }
            // Session to be same for current users:
            if (response?.collaborator_data?.connected_id) {
              Cookies.set("X-ST-ID", response?.collaborator_data?.connected_id, { domain: checkForDomain() });
            }
            response?.userData?.token && setTokenForAuthorization(response?.userData?.token, checkForDomain());
            Cookies.set("email", result?.user?.email)
            if (currentLOcation?.includes("register") && searchParams.get("ref")) {
              Cookies.set("ref", searchParams.get("ref"))
            }
            // Cookies.set("is_profile_complete", response?.is_profile_completed);
            if (response?.is_profile_completed == true) {
              // console.log(currentLOcation,"path")
              Cookies.set("is_profile_complete", true, { domain: checkForDomain() })
              navigate(currentLOcation !== "/login" && currentLOcation !== "/verification" && currentLOcation !== "/register" ? currentLOcation : "/");
            }
            else {
              Cookies.set("is_profile_complete", false, { domain: checkForDomain() })
              // navigate(onboardingRoute + "?page=" + Number(response?.step));
              navigate(onboardingRoute);
              Cookies.set("step", Number(response?.step))
            }
          }
        });
      })
      .catch((error) => {
        console.error('Error signing in:', error);
      });
  };

  const handleSubmit = () => {
    let emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (emailPattern?.test(emailValue)) {
      handleLogin();
    }
    else {
      setEmailError(true);
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Typography sx={{ fontSize: { xs: "1.75rem", sm: "2rem" }, fontWeight: 700, color: "#101828", textAlign: "center", lineHeight: 1.2 }}>
        For Startups
      </Typography>
      <Typography sx={{ color: "#667085", textAlign: "center", mt: 1, fontSize: "1rem" }}>
        Continue with Backrr Account
      </Typography>

      <Box sx={{ mt: { xs: 3, sm: 4 } }}>
        <CustomInputField
          value={emailValue}
          onKeyDown={(e) => { if (e.key === "Enter") { handleSubmit(); } }}
          onChange={(event) => {
            let inputValue = event?.target?.value.trim();
            if (inputValue.length <= 60) {
              if (inputValue.startsWith("mailto:")) {
                inputValue = inputValue?.replace(/^mailto:/, "")?.replaceAll(" ", "");
              }
              setEmailValue(inputValue?.toLowerCase())?.replaceAll(" ", "");
            }
            setEmailError(false);
          }}
          hasError={emailError}
          errorMessage={emailValue?.length > 0 ? emailError ? "Something went wrong." : "Please enter a valid email." : "Email is required."}
          label="Email"
          labelStyle={{ textTransform: "none", color: "#344054", fontWeight: 500, fontSize: "0.875rem", marginBottom: "8px" }}
          fullWidth
          type="email"
          placeholder="Enter your email"
          sx={INPUT_SX}
        />
      </Box>

      <Primary
        disabled={isLoading && loginMethod === "email"}
        sx={{ mt: 3, fontSize: '1rem' }}
        fullWidth
        onClick={() => { handleSubmit(); }}
      >
        {isLoading && loginMethod === "email" ?
          <CircularProgress sx={{ color: "white", marginInline: 'auto' }} size={'1.4rem'} />
          : "Continue with Email"}
      </Primary>

      <Box sx={{ display: "flex", alignItems: "center", gap: 2, my: 3 }}>
        <Divider sx={{ flex: 1, borderColor: "#E5E7EB" }} />
        <Typography sx={{ color: "#98A2B3", fontSize: "0.95rem" }}>or</Typography>
        <Divider sx={{ flex: 1, borderColor: "#E5E7EB" }} />
      </Box>

      <Box sx={{ display: "grid", gap: "1rem" }}>
        <GoogleLogin userData={userData} setUserData={setUserData} signin={loginViaEmailAsync} loginMethod={loginMethod} setLoginMethod={setLoginMethod} isLoading={isLoading} />
        <LinkedinLogin userData={userData} setUserData={setUserData} signin={loginViaEmailAsync} loginMethod={loginMethod} setLoginMethod={setLoginMethod} isLoading={isLoading} />
      </Box>

      <Typography sx={{ textAlign: "center", color: "#667085", mt: 3, fontSize: "0.95rem" }}>
        Are you an Investor?{" "}
        <Box
          component="span"
          tabIndex={0}
          role="button"
          onClick={() => { redirectTo(currentIP); }}
          onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { redirectTo(currentIP); } }}
          sx={{ color: "#5046E5", fontWeight: 600, cursor: "pointer", "&:hover": { textDecoration: "underline" } }}
        >
          Click here
        </Box>
      </Typography>
    </Box>
  );
};

export default AuthLogin